// src/config.js

const PROD_SERVER =
  process.env.REACT_APP_API_URL !== undefined
    ? process.env.REACT_APP_API_URL
    : 'https://findmarks.ru';
const DEV_SERVER = process.env.REACT_APP_DEV_SERVERNAME || 'http://localhost:3002';
const USE_LOCAL_SERVER =
  process.env.REACT_APP_USE_LOCAL_SERVER === '1' ||
  process.env.REACT_APP_USE_LOCAL_SERVER === 'true';

let serverName = PROD_SERVER;
let listenerName = PROD_SERVER;

if (USE_LOCAL_SERVER) {
  serverName = DEV_SERVER;
  listenerName = process.env.REACT_APP_DEV_LISTENER || DEV_SERVER;
}

console.log(`*********************************************************************************`);
console.log(`************${new Date()}*************`);
console.log(`API server: ${serverName || '(same origin)'}${USE_LOCAL_SERVER ? ' (local)' : ' (prod)'}`);
console.log('run from URL: ' + (listenerName || '(same origin)'));

/**
 * URL для socket.io. serverName === '' (docker: REACT_APP_API_URL=) → undefined, клиент берёт текущий origin.
 * namespace: '/admin' → io('/admin') или io('https://host/admin').
 */
function getSocketIoUrl(namespace = '') {
  const base =
    serverName === '' ? undefined : serverName || 'https://findmarks.ru';
  if (!namespace) {
    return base;
  }
  const ns = namespace.startsWith('/') ? namespace : `/${namespace}`;
  if (!base) {
    return ns;
  }
  return `${base.replace(/\/$/, '')}${ns}`;
}

export { serverName, listenerName, getSocketIoUrl };
